export const suppliesContent = {
  sectionTag: 'Catálogo de Suministros',
  headline: 'Insumos de calidad certificada para operaciones marítimas exigentes',
  intro:
    'Cada producto en nuestro catálogo cumple con estándares internacionales de calidad y seguridad. No distribuimos insumos genéricos: seleccionamos proveedores auditados y verificamos cada lote antes de embarque. Desde provisiones frescas hasta equipo de salvamento certificado, nuestra cadena de suministro garantiza trazabilidad, cadena de frío y documentación técnica completa.',
  cta: 'Ver Catálogo Completo',
  categories: [
    {
      id: 'provisiones',
      name: 'Provisiones',
      tag: 'Fresh',
      description:
        'Frutas, verduras, carnes rojas, cortes americanos, carnes frías, pescados, congelados, bebidas, artículos personales y abarrotes.',
      icon: 'ri-restaurant-line',
      image: 'provisiones',
      items: [
        'Frutas y verduras frescas',
        'Carnes rojas y cortes americanos',
        'Carnes frías y embutidos',
        'Pescados y mariscos',
        'Congelados y ultracongelados',
        'Bebidas, cervezas, refrescos',
        'Vinos y licores',
        'Abarrotes, dulces, botanas',
        'Cigarros y artículos personales',
        'Agua embotellada',
      ],
    },
    {
      id: 'consumibles-cabina',
      name: 'Consumibles de Cabina',
      tag: 'Cabin',
      description:
        'Utensilios de cocina y bar, artículos de escritorio, equipos médicos, consumibles de limpieza, línea blanca, higiene y ferretería de cabina.',
      icon: 'ri-hotel-bed-line',
      image: 'consumibles',
      items: [
        'Utensilios de cocina y bar',
        'Artículos de escritorio y oficina',
        'Equipos y suministros médicos',
        'Consumibles de limpieza',
        'Línea blanca',
        'Artículos de higiene personal',
        'Suministros para baños',
        'Cepillos y utensilios domésticos',
        'Ferretería de cabina',
      ],
    },
    {
      id: 'cubierta-maquinas',
      name: 'Cubierta y Máquinas',
      tag: 'Deck',
      description:
        'Cabos marinos, equipo de carga, artículos de seguridad, mangueras, lubricantes, herramientas, tubos, válvulas, baleros, equipo de soldadura y eléctrico.',
      icon: 'ri-anchor-line',
      image: 'cubierta',
      items: [
        'Cabos marinos y amarras',
        'Equipo para carga y estiba',
        'Artículos de seguridad industrial',
        'Mangueras y conexiones',
        'Lubricantes marinos',
        'Herramientas de mano',
        'Tubos, conexiones y válvulas',
        'Baleros y rodamientos',
        'Equipo de soldadura',
        'Equipo eléctrico',
        'Juntas y empaques',
        'Aceros y maquinados',
        'Equipos de medición',
      ],
    },
    {
      id: 'cartas-publicaciones',
      name: 'Cartas y Publicaciones',
      tag: 'Navigational',
      description:
        'Cartas náuticas británicas, americanas, japonesas, australianas y canadienses. Avisos a marinos, catálogos, tablas de mareas y señales.',
      icon: 'ri-map-2-line',
      image: 'cartas',
      items: [
        'Cartas Británicas',
        'Cartas Americanas USCG',
        'Cartas Japonesas',
        'Cartas Australianas',
        'Cartas Canadienses',
        'Avisos a marinos',
        'Catálogos y publicaciones',
        'Tablas de mareas',
        'Lista de señales de luz y niebla',
        'Lista de radio señales',
        'Tablas de distancias',
        'Instrucciones de salida de puertos',
      ],
    },
    {
      id: 'salvamento',
      name: 'Equipo de Salvamento',
      tag: 'Safety',
      description:
        'Raciones de emergencia, silbatos, reflectores, cinta reflectante, chalecos salvavidas, botiquines, aros, extinguidores y mangueras contra incendios.',
      icon: 'ri-lifebuoy-line',
      image: 'salvamento',
      items: [
        'Raciones de comida y agua',
        'Silbatos de emergencia',
        'Reflectores de radar',
        'Cinta reflectante',
        'Chalecos salvavidas',
        'Botiquín de primeros auxilios',
        'Luces para chalecos',
        'Aros salvavidas',
        'Extinguidores',
        'Mangueras contra incendios',
      ],
    },
    {
      id: 'pirotecnia',
      name: 'Pirotecnia',
      tag: 'Emergency',
      description:
        'Señales con paracaídas, de humo, bengalas de mano, señal de hombre al agua, lanza cabos, boyas automáticas con señal de humo y luz.',
      icon: 'ri-fire-line',
      image: 'pirotecnia',
      items: [
        'Señales con paracaídas',
        'Señales de humo',
        'Bengalas de mano',
        'Señal de hombre al agua',
        'Lanza cabos',
        'Boya automática con señal de humo y luz',
      ],
    },
  ],
};